module.exports = __webpack_public_path__ + "img/5.e460066f.png";